import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import { Icon } from '@mui/material'
import { ReactElement, useCallback, useEffect, useState } from 'react'
import {
    inviteUserInGroup,
    updateUserInGroup,
} from '../../services/groupsServices'
import { IAddUser } from './interfaces'
import { CloseOutlined } from '@mui/icons-material'
import SelectUser from './SelectUser'
import theme from '../../theme/theme'
import { useTranslation } from 'react-i18next'
import PaperModalComponent from '../Common/PaperModalComponent'

const AddUserInGroup = (props: IAddUser): ReactElement => {
    const { t } = useTranslation()
    const { openAddOrEditUser, org, handleAddOrEditUser, groupId } = props
    const { open, mode, formData: data } = openAddOrEditUser
    const { totalUsers } = data
    data.role = data.role
        ? data.role[0].toUpperCase() + data.role.substring(1)
        : ''
    const role = totalUsers === 0 ? 'Admin' : data.role
    const [formData, setFormData] = useState({ ...data, role })
    const [errors, setErrors] = useState<{ email?: string }>({})
    const [isUpdated, setIsUpdated] = useState<boolean>(true)

    const validateForm = useCallback(() => {
        let isValid = true
        const errors: { email?: string } = {}

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        const isValidEmail = emailRegex.test(formData.email)
        if (!formData.email) {
            errors.email = t('emailRequired')
            isValid = false
        } else if (!isValidEmail) {
            errors.email = t('emailInvalid')
            isValid = false
        }
        setErrors(errors)
        return isValid
    }, [formData.email, t])

    const clearForm = useCallback(() => {
        setFormData({
            email: '',
            role: '',
        })
        setErrors({})
    }, [])

    const handleSubmit = useCallback(
        async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault()
            if (validateForm()) {
                if (mode === 'Add') {
                    await inviteUserInGroup(
                        {
                            email: formData.email,
                            groupId,
                        },
                        org.id,
                    )
                } else {
                    const payload = {
                        email: formData.email,
                        groupId,
                    }
                    await updateUserInGroup(payload, org)
                }

                // handleClose()
                clearForm()
                handleAddOrEditUser(true)
            }
        },
        [
            validateForm,
            mode,
            formData.email,
            groupId,
            org,
            clearForm,
            handleAddOrEditUser,
        ],
    )

    const handleInputChange = useCallback(
        (id: string, value: string) => {
            setFormData({ ...formData, email: value })
            setErrors({})
        },
        [formData],
    )

    useEffect(() => {
        if (role === formData.role && mode !== 'Add') {
            setIsUpdated(false)
        } else {
            setIsUpdated(true)
        }
    }, [formData.role, mode, role])

    return (
        <div>
            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <PaperModalComponent>
                    <form onSubmit={handleSubmit}>
                        <Box
                            sx={{
                                p: 4,
                                boxShadow: 4,
                                borderRadius: 4,
                                position: 'absolute' as const,
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 400,
                                backgroundColor: '#fff',
                                border: `2px solid ${theme.palette.primary.main}`,
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '15px',
                                    cursor: 'pointer',
                                }}
                            >
                                <Icon
                                    onClick={() => handleAddOrEditUser(false)}
                                    sx={{ marginRight: '8px' }}
                                    fontSize="small"
                                    id="close-icon"
                                >
                                    <CloseOutlined
                                        sx={{
                                            color: '#000',
                                            marginTop: '-2px',
                                        }}
                                    />
                                </Icon>
                            </Box>
                            <Typography
                                variant="h6"
                                component="h2"
                                id="draggable-modal-title"
                                sx={{ cursor: 'move' }}
                            >
                                {mode === 'Edit' ? t('editUser') : t('addUser')}
                            </Typography>
                            {/* <Box sx={{ mt: 2 }}>
                            <TextField
                                id="add-userInGroup-email"
                                name="email"
                                label="User Email *"
                                variant="outlined"
                                value={formData.email}
                                onChange={handleInputChange}
                                error={!!errors.email}
                                helperText={errors.email}
                                fullWidth
                                disabled={mode === 'Edit'}
                            />
                        </Box> */}
                            <Box sx={{ mt: 2.5, mb: 1 }}>
                                <SelectUser
                                    id="add-userInGroup-email"
                                    label={t('userEmail')}
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    disabled={mode === 'Edit'}
                                    errorMessage={
                                        errors.email ? errors.email : ''
                                    }
                                    required={true}
                                    isLegend={true}
                                />
                            </Box>
                            <Button
                                sx={{
                                    mt: 2,
                                }}
                                variant="contained"
                                fullWidth
                                id="add-userInGroup-submit-button"
                                disabled={!isUpdated}
                                type="submit"
                            >
                                {t('submit')}
                            </Button>
                        </Box>
                    </form>
                </PaperModalComponent>
            </Modal>
        </div>
    )
}

export default AddUserInGroup
